/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { components } from '@atlaskit/select/react-select';
import type { ClearIndicatorProps } from '@atlaskit/select/types';
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@compiled/react';

const AsyncTooltip = React.lazy(() =>
	import(/* webpackChunkName: "@atlaskit-internal_@atlaskit/tooltip" */ '@atlaskit/tooltip').then(
		(module) => {
			return {
				default: module.default,
			};
		},
	),
);

const clearIndicatorStyles = cssMap({
	root: {
		opacity: 1,
		'@media (hover: hover) and (pointer: fine)': {
			// TODO: remove !important once the Select styles props is removed https://product-fabric.atlassian.net/browse/DSP-22497
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
			opacity: '0 !important',
		},
		transition: 'color 150ms, opacity 150ms',
		paddingTop: token('space.0'),
		paddingRight: token('space.0'),
		paddingBottom: token('space.0'),
		paddingLeft: token('space.0'),
		'&:hover': {
			color: token('color.icon.danger'),
		},
	},
});

export class ClearIndicator extends React.PureComponent<ClearIndicatorProps<any>> {
	private handleMouseDown = (event: React.MouseEvent) => {
		if (event && event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		// Prevent focus when clear on blurred state
		const { clearValue, selectProps } = this.props;
		clearValue();
		if (selectProps && !selectProps.isFocused) {
			event.stopPropagation();
		}
	};

	render(): JSX.Element {
		const {
			selectProps: { clearValueLabel },
		} = this.props;
		const Indicator = (
			<components.ClearIndicator
				{...this.props}
				innerProps={{
					...this.props.innerProps,
					onMouseDown: this.handleMouseDown,
				}}
				xcss={clearIndicatorStyles.root}
			/>
		);
		return clearValueLabel ? (
			<React.Suspense fallback={Indicator}>
				<AsyncTooltip content={clearValueLabel}>{Indicator}</AsyncTooltip>
			</React.Suspense>
		) : (
			Indicator
		);
	}
}
